import { twMerge } from 'tailwind-merge';

import { PostViewOptions } from '../../constants/constants';
import type { PostComment as PostCommentType } from '../../types/PostComment';
import { PostComment } from '../PostComment/PostComment';
import { TagContent } from '../../../TagContent/TagContent';

interface PostCommentsProps {
  postComments: PostCommentType[];
  className?: string;
  onViewChange: (viewName: PostViewOptions, viewCatchId?: string) => void;
}

export const PostComments = ({ postComments, className, onViewChange }: PostCommentsProps) => {
  const handleNotLoggedIn = (): void => {
    onViewChange('registerWallView');
  };

  return (
    <section className={twMerge('flex flex-col gap-y-6', className)} data-testid="PostComments">
      {postComments.map(
        ({
          _id: commentId,
          text: commentText,
          user: commentUser,
          createdAt: commentDate,
          likesCount,
          likedByCurrentUser,
          comments,
        }) => {
          return (
            commentText.text && (
              <PostComment
                avatarUrl={commentUser.avatar?.url || ''}
                date={new Date(commentDate)}
                key={commentId}
                likeCount={likesCount}
                likedByCurrentUser={likedByCurrentUser}
                nickname={commentUser.nickname || ''}
                onNotLoggedIn={handleNotLoggedIn}
                postId={commentId}
                replies={comments}
              >
                <TagContent id={commentUser._id} text={commentText.text} url="/tags/" />
              </PostComment>
            )
          );
        },
      )}
    </section>
  );
};
